import { initialRequestStatusState, RequestStatusState } from '@portal/shared/store/request-status';
import {
  Applicable,
  EditReportGroupsFormData,
  GroupStatus
} from 'src/app/pages/administration/report-groups/report-groups.types';

export interface MapReportGroupState {
  selectedArea: [number, number][];
  selectedIds: string[];
  reportGroupFormData: EditReportGroupsFormData | undefined;
  hasPausedReportGroup: boolean;
  createReportGroupRequest: RequestStatusState;
  isReportGroupCalculating: boolean;
  initialApplicable: Applicable;
}

export const initialState: MapReportGroupState = {
  selectedArea: [],
  selectedIds: [],
  reportGroupFormData: {
    groupName: '',
    groupCriteria: [],
    groupDescription: '',
    groupStatus: GroupStatus.Active
  },
  hasPausedReportGroup: false,
  createReportGroupRequest: initialRequestStatusState,
  isReportGroupCalculating: false,
  initialApplicable: Applicable.NetworkMonitoring
};
